
import { useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Experts from './components/Experts';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SEOHead from '../../components/SEOHead';

export default function Home() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "伝説のヘッドスパ",
    "description": "45年間の化粧品・ヘアケア開発経験を持つ専門家による、一人ひとりに合わせた丁寧なヘッドスパケアをご提供。",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`,
    "telephone": "0120-600-226",
    "email": "info@densetsu-spa.com",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "JP"
    },
    "openingHours": "Mo-Fr 10:00-17:00",
    "sameAs": [],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "127"
    },
    "service": [
      {
        "@type": "Service",
        "name": "ヘッドスパ",
        "description": "専門家による丁寧なヘッドスパケア"
      },
      {
        "@type": "Service", 
        "name": "頭皮ケア",
        "description": "一人ひとりに合わせた頭皮ケア"
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="伝説のヘッドスパ | 45年の経験による専門ケア"
        description="45年間の化粧品・ヘアケア開発経験を持つ専門家による、一人ひとりに合わせた丁寧なヘッドスパケアをご提供。医師監修・アーユルヴェーダ研究者による総合的なアプローチで美と健康をサポートします。"
        keywords="ヘッドスパ,発毛,育毛,頭皮ケア,化粧品開発,専門家,カウンセリング,リラクゼーション"
        ogTitle="伝説のヘッドスパ | 45年の経験による専門ケア"
        ogDescription="45年間の化粧品・ヘアケア開発経験を持つ専門家による、一人ひとりに合わせた丁寧なヘッドスパケアをご提供。"
        schema={schema}
      />
      <Hero />
      <About />
      <Experts />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}
